<mat-card class="errorLog-block">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{ "dashboardBizzDev.errorLog.title.shortLabel" | translate }}
                <app-tooltip
                    text="{{
                        'dashboardBizzDev.errorLog.title.summary' | translate
                    }}"
                ></app-tooltip>
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-height">
        <form [formGroup]="dateForm" (ngSubmit)="GetErrorsLog()">
            <fieldset>
                <legend>
                    {{
                        "dashboardBizzDev.errorLog.dateForm.table.title.shortLabel"
                            | translate
                    }}
                </legend>
                <mat-form-field>
                    <mat-label>{{
                        "dashboardBizzDev.errorLog.dateForm.table.start.shortLabel"
                            | translate
                    }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="minDatePicker"
                        formControlName="minDate"
                        name="minDate"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="minDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #minDatePicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>{{
                        "dashboardBizzDev.errorLog.dateForm.table.end.shortLabel"
                            | translate
                    }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="maxDatePicker"
                        formControlName="maxDate"
                        name="maxDate"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="maxDatePicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #maxDatePicker></mat-datepicker>
                </mat-form-field>
            </fieldset>
            <section class="actions">
                <button
                    type="submit"
                    mat-icon-button
                    color="accent"
                    [disabled]="dateForm.invalid"
                >
                    <mat-icon aria-label="Validate">check</mat-icon>
                </button>
                <button
                    mat-icon-button
                    color="accent"
                    matTooltip="{{
                        'dashboardBizzDev.errorLog.buttons.documentation.detail'
                            | translate
                    }}"
                    routerLink="/dashboardBizzDev/details/errorDetail"
                >
                    <mat-icon aria-label="Documentation">description</mat-icon>
                </button>
            </section>
        </form>

        <table
            mat-table
            [dataSource]="dataSource"
            matSort matSortDisableClear
            class="tab-content"
            matSortActive="_InsertTimeSpan"
            matSortDirection="desc"
            multiTemplateDataRows
        >
            <!-- Procedure Column -->
            <ng-container matColumnDef="procedureName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{
                        "dashboardBizzDev.errorLog.table.procedure.shortLabel"
                            | translate
                    }}
                </th>
                <tr>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon
                            [ngStyle]="{ cursor: 'pointer' }"
                            (click)="
                                expandedElement =
                                    expandedElement === element ? null : element
                            "
                        >
                            {{
                                expandedElement === element
                                    ? "expand_more"
                                    : "chevron_right"
                            }}
                        </mat-icon>
                        <span>{{ element.procedureName }}</span>
                    </td>
                </tr>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="_InsertTimeSpan">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{
                        "dashboardBizzDev.errorLog.table.date.shortLabel"
                            | translate
                    }}
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element._InsertTimeSpan | date: "dd/MM/yyyy HH:mm" }}
                </td>
            </ng-container>

            <!-- DETAILS -->
            <ng-container matColumnDef="expandedDetail">
                <td
                    mat-cell
                    *matCellDef="let element"
                    [attr.colspan]="displayedColumns.length"
                >
                    <div
                        class="example-element-detail"
                        [@detailExpand]="
                            element == expandedElement
                                ? 'expanded'
                                : 'collapsed'
                        "
                    >
                        <div class="error-detail" [innerHtml]="element.errorMessage"></div>
                    </div>
                </td>
            </ng-container>
            <!-- CHECKED BUTTON-->
            <ng-container matColumnDef="checked">
                <th mat-header-cell *matHeaderCellDef>
                    {{
                        "dashboardBizzDev.errorLog.table.seen.shortLabel"
                            | translate
                    }}
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox
                        class="example-margin"
                        [checked]="element.checked"
                        [(disabled)]="element.checked"
                        (change)="errorHasBeenChecked(element.id)"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let element; columns: displayedColumns"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: ['expandedDetail']"
                class="example-detail-row"
            ></tr>
        </table>
    </mat-card-content>
</mat-card>
